import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlightSearch',
    standalone: true
})
export class HighlightSearchPipe implements PipeTransform {
    transform(value: string, args: string): any {
        if (!args) { return value; }
        const re = new RegExp(args, 'gi');
        return value.replace(re, "<span class='highlight-search-text'>$&</span>");
    }
}
